import { render, staticRenderFns } from "./kids_queue.vue?vue&type=template&id=d5ff2fbc&"
import script from "./kids_queue.vue?vue&type=script&lang=js&"
export * from "./kids_queue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports